/*@flow*/
import * as t from 'lib/t';
import { Id, NormalizedNumber } from 'types/tcomb';
import mkTagTemplate from 'lib/templates/mkTagTemplate';
import isEmbedded from 'lib/isEmbedded';

const config = {
  id: t.maybe(Id).options({ type: 'hidden' }),
  name: t.String.opt({
    attrs: {
      autoComplete: 'off',
    },
  }),
  description: t
    .maybe(t.String)
    .options({ type: 'textarea', template: 'TextEditorTemplate' }),
  address: t.maybe(t.String).options({
    template: 'LocationPickerTemplate',
  }),
  theGeom: t.maybe(t.String.options({ type: 'hidden' })),
  category: t.String.options({
    template: 'OrganizationCategory',
    attrs: {
      placeholder: 'Select...',
      classNamePrefix: 'Select',
    },
  }),
  subcategories: t.maybe(t.list(t.String)).options({
    template: 'OrganizationSubcategory',
    attrs: {
      placeholder: 'Select...',
      classNamePrefix: 'Select',
    },
  }),
  tags: t.maybe(t.list(t.String)).options({
    template: mkTagTemplate('tenants'),
    attrs: {
      placeholder: 'Select...',
      classNamePrefix: 'Select',
    },
  }),
  status: t.String.options({
    template: 'OrganizationStatus',
    hideWhen: isEmbedded,
    attrs: {
      placeholder: 'Choose status of organization',
      classNamePrefix: 'Select',
    },
  }),
  website: t.maybe(t.String).options({
    label: 'Website',
  }),
  phone: t.maybe(t.String),
  estimatedAnnualBudget: t.maybe(NormalizedNumber).options({
      label: 'Estimated Annual Budget',
    }),
  notes: t
    .maybe(t.String)
    .options({ type: 'textarea', template: 'TextEditorTemplate' }),

  billingCity: t.maybe(t.String).opt({
    before: {
      tag: 'h4',
      props: {
        children: 'Private Information',
        className: 'mt-5 font-weight-bold',
      },
    },
  }),
  billingCountry: t.maybe(t.String),
  billingZip: t.maybe(t.String),
  billingState: t.maybe(t.String),
  billingStreet1: t.maybe(t.String),
  billingStreet2: t.maybe(t.String),

  contactIds: t.maybe(t.list(Id)).opt({
    before: {
      tag: 'h3',
      props: { children: 'Associated Records', className: 'mt-5' },
    },
    after: {
      tag: 'div',
      props: { className: 'mb-5 mt-5' },
    },
    template: 'Contacts',
    label: 'Contacts',
    attrs: {
      placeholder: 'Select Contact',
      classNamePrefix: 'SelectRecordContacts',
    },
    hideWhen: isEmbedded,
  }),
  primaryContactName: t.maybe(t.String).opt({
    before: {
      tag: 'h3',
      props: { children: 'Primary Contact', className: 'mt-5' },
    },
    label: 'Name',
    hideWhen: isEmbedded,
  }),
  primaryContactPhone: t
    .maybe(t.String)
    .opt({ label: 'Phone', hideWhen: isEmbedded }),
  primaryContactEmail: t
    .maybe(t.String)
    .opt({ label: 'Email', hideWhen: isEmbedded }),
  secondaryContactName: t.maybe(t.String).opt({
    before: {
      tag: 'h3',
      props: { children: 'Secondary Contact', className: 'mt-5' },
    },
    label: 'Name',
    hideWhen: isEmbedded,
  }),
  secondaryContactPhone: t
    .maybe(t.String)
    .opt({ label: 'Phone', hideWhen: isEmbedded }),
  secondaryContactEmail: t
    .maybe(t.String)
    .opt({ label: 'Email', hideWhen: isEmbedded }),
  tertiaryContactName: t.maybe(t.String).opt({
    before: {
      tag: 'h3',
      props: { children: 'Tertiary Contact', className: 'mt-5' },
    },
    label: 'Name',
    hideWhen: isEmbedded,
  }),
  tertiaryContactPhone: t
    .maybe(t.String)
    .opt({ label: 'Phone', hideWhen: isEmbedded }),
  tertiaryContactEmail: t
  .maybe(t.String)
  .opt({ label: 'Email', hideWhen: isEmbedded }),
};

export default t.struct(config, 'Organization').opt<any>({ legend: '' });
